type Props = { projectId: string };

/**
 * ForbiddenView — empty-state shown when the daemon returns 403 for a project.
 * Common cause: the user's email was removed from projects.json, or the sidebar
 * is stale (project still listed locally but no longer accessible).
 *
 * Provides a friendly explanation + manual refresh, so the user can recover
 * without reloading the whole app once an admin restores access.
 */
export default function ForbiddenView({ projectId }: Props) {
  return (
    <div className="forbidden-view" role="alert">
      <div className="forbidden-icon" aria-hidden="true">🔒</div>
      <h2 className="forbidden-title">No access to {projectId}</h2>
      <p className="forbidden-body">
        You do not have access to this project. Ask an admin to assign it to you
        in the Users panel, or refresh the page if access was just granted.
      </p>
      <button
        type="button"
        className="forbidden-refresh-btn"
        onClick={() => window.location.reload()}
      >
        Refresh
      </button>
    </div>
  );
}
